/*
 * @Author: Hyman Choi
 * @Date: 2021-01-08 16:08:56
 * @LastEditTime: 2022-01-14 16:42:12
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Siui.Cloud.Medical.Web\src\router\Modules\app.js
 */
import Layout from '@/layout'

const appRouter = {
  path: '/appManagement',
  component: Layout,
  redirect: '/appManagement/userStatistics',
  name: 'appManagement',
  meta: {
    roles: ['超级管理员'],
    title: 'appManagement',
    icon: 'appManagement'
  },
  children: [
    {
      path: 'versionManagement',
      name: 'versionManagement',
      component: () => import('@/views/appManagement/versionManagement/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'versionManagement'
      }
    },
    {
      path: 'downloadManagement',
      name: 'downloadManagement',
      component: () => import('@/views/appManagement/downloadManagement/index'),
      meta: {
        roles: ['超级管理员'],
        title: 'downloadManagement'
      }
    }
  ]
}

export default appRouter
